import { render, staticRenderFns } from "./Greeting-Office.vue?vue&type=template&id=13fac3f4&scoped=true"
import script from "./Greeting-Office.vue?vue&type=script&lang=js"
export * from "./Greeting-Office.vue?vue&type=script&lang=js"
import style0 from "./Greeting-Office.vue?vue&type=style&index=0&id=13fac3f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fac3f4",
  null
  
)

export default component.exports